import { serverFlagAnswer } from '~/utils/featureFlags/serverFlagAnswer';

export default defineNuxtRouteMiddleware(async (to) => {
  const enabledFlag = to.meta.requiresFeatureFlagEnabled;

  if (!enabledFlag?.flagName) {
    return;
  }

  // navigateTo runs after an await here, so the Nuxt context (needed by
  // clusterRedirectPath) must be re-bound — see 00.auth-route-protection.
  const nuxtApp = useNuxtApp();

  // The server's answer where the page already has one, so a page linked from server-flagged UI
  // agrees with it even when the browser cannot reach Unleash.
  const isFlagEnabled = await serverFlagAnswer(enabledFlag.flagName);
  if (!isFlagEnabled) {
    return await nuxtApp.runWithContext(() => navigateTo(clusterRedirectPath(enabledFlag.routeTo ?? '/')));
  }
});
